module.exports = __webpack_public_path__ + "static/media/timelapse.46d0373d.mp4";